function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigationChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.71 8.06"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m.35.35 7 7 7-7",
  style: {
    fill: "none",
    stroke: "#007c76",
    strokeMiterlimit: 10
  }
}));
export default SvgNavigationChevronDown;